import { EnvelopeIcon } from '@heroicons/react/24/outline'
import { TeamView } from '../../api/client'
import TeamUsersDisplay from './TeamUsersDisplay'

type Props = {
    team: TeamView
}

function TeamDetails(props: Props) {
    const { team } = props

    // A team for this user could not be found - this is most likely an error.
    // If the user does not have a team then the NoTeam component will be rendered instead.
    if (!!!team) {
        throw Error('Unable to display team details. Please try again.')
    }

    return (
        <section className="overflow-hidden rounded-lg border border-ink-200 bg-white shadow-sm">
            <header className="border-b border-ink-100 px-6 py-5">
                {/* UPPERCASE tracked eyebrow labels the section (arwen design system). */}
                <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-400">
                    Team
                </p>
                {/* font-sans overrides the global Merriweather heading rule in index.css —
                    in-app headings are Jost, with hierarchy from size not weight. */}
                <h2 className="mt-1 font-sans text-xl font-medium leading-tight text-ink-900">
                    {team.name}
                </h2>
            </header>
            <div className="px-6 py-5">
                <TeamUsersDisplay teamId={team.id} />
            </div>
            <footer className="flex flex-wrap items-center justify-between gap-3 border-t border-ink-100 bg-ink-50 px-6 py-4">
                <p className="text-sm text-ink-500">
                    Need to add, remove or change someone on this team?
                </p>
                <a
                    href={`mailto:support@arwen.ai?subject=${encodeURIComponent(
                        `Team change request: ${team.name}`
                    )}`}
                    className="inline-flex flex-none items-center gap-1.5 rounded-md bg-arwen-600 px-3.5 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-arwen-700 focus:outline-none focus:ring-2 focus:ring-arwen-500 focus:ring-offset-2"
                >
                    <EnvelopeIcon className="h-4 w-4" aria-hidden="true" />
                    Contact support
                </a>
            </footer>
        </section>
    )
}

export default TeamDetails
